export const ALERT = 'ALERT'
export const AUTHENTICATION_FAILURE = 'AUTHENTICATION_FAILURE'
export const AUTHENTICATION_REQUEST = 'AUTHENTICATION_REQUEST'
export const AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS'
export const CLIENT_CREATED = 'CLIENT_CREATED'
export const CONTACT_FORM_SENT = 'CONTACT_FORM_SENT'
export const CONSULTATION_MODAL_CLOSED = 'CONSULTATION_MODAL_CLOSED'
export const CONSULTATION_MODAL_OPENED = 'CONSULTATION_MODAL_OPENED'
export const CONTACT_MODAL_CLOSED = 'CONTACT_MODAL_CLOSED'
export const CONTACT_MODAL_OPENED = 'CONTACT_MODAL_OPENED'
export const CREATE_ALERT_SUCCESS = 'CREATE_ALERT_SUCCESS'
export const CREATE_FAVORITE_SUCCESS = 'CREATE_FAVORITE_SUCCESS'
export const DELETE_ALERT_SUCCESS = 'DELETE_ALERT_SUCCESS'
export const DELETE_FAVORITE_SUCCESS = 'DELETE_FAVORITE_SUCCESS'
export const FETCH_ALERTS_SUCCESS = 'FETCH_ALERTS_SUCCESS'
export const FETCH_CLIENTS_SUCCESS = 'FETCH_CLIENTS_SUCCESS'
export const FETCH_FAVORITES_SUCCESS = 'FETCH_FAVORITES_SUCCESS'
export const FETCH_FAVORITE_PROPERTY_SUCCESS = 'FETCH_FAVORITE_PROPERTY_SUCCESS'
export const FETCH_PROPERTY_REQUEST = 'FETCH_PROPERTY_REQUEST'
export const FETCH_PROPERTY_SUCCESS = 'FETCH_PROPERTY_SUCCESS'
export const FETCH_PROPERTY_FAILURE = 'FETCH_PROPERTY_FAILURE'
export const FETCH_PROPERTIES_REQUEST = 'FETCH_PROPERTIES_REQUEST'
export const FETCH_PROPERTIES_SUCCESS = 'FETCH_PROPERTIES_SUCCESS'
export const FETCH_PROPERTIES_FAILURE = 'FETCH_PROPERTIES_FAILURE'
export const FETCH_OFFERS_SUCCESS = 'FETCH_OFFERS_SUCCESS'
export const FETCH_RECIPIENTS_SUCCESS = 'FETCH_RECIPIENTS_SUCCESS'
export const FETCH_TOURS_SUCCESS = 'FETCH_TOURS_SUCCESS'
export const FETCH_WALKSCORE_SUCCESS = 'FETCH_WALKSCORE_SUCCESS'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'
export const HIDE_ALERT = 'HIDE_ALERT'
export const LOGOUT = 'LOGOUT'
export const NEWSLETTER_SIGNUP_SUCCESS = 'NEWSLETTER_SIGNUP_SUCCESS'
export const REBATE_TERMS_MODAL_CLOSED = 'REBATE_TERMS_MODAL_CLOSED'
export const REBATE_TERMS_MODAL_OPENED = 'REBATE_TERMS_MODAL_OPENED'
export const RESET_FAVORITE_PROPERTIES = 'RESET_FAVORITE_PROPERTIES'
export const SIGNUP_ERROR = 'SIGNUP_ERROR'
export const TOUR_MODAL_CLOSED = 'TOUR_MODAL_CLOSED'
export const TOUR_MODAL_OPENED = 'TOUR_MODAL_OPENED'
export const UPDATE_ALERT_SUCCESS = 'UPDATE_ALERT_SUCCESS'
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE'
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS'
export const WELCOME_MODAL_CLOSED = 'WELCOME_MODAL_CLOSED'
export const WELCOME_MODAL_OPENED = 'WELCOME_MODAL_OPENED'
export const FETCH_OPEN_HOUSES_REQUEST = 'FETCH_OPEN_HOUSES_REQUEST'
export const FETCH_OPEN_HOUSES_SUCCESS = 'FETCH_OPEN_HOUSES_SUCCESS'
export const FETCH_OPEN_HOUSES_FAILURE = 'FETCH_OPEN_HOUSES_FAILURE'



// WEBPACK FOOTER //
// ./src/constants.js